// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';

import * as syncActionCreators from '../../../redux/actionCreators/sync';
import * as asyncActionCreators from '../../../redux/actionCreators/async';
import {applicantAssessmentUrls} from '../../../redux/actionCreators/async/assessments';
import {getAssessments} from '../../../utils/assessmentRules';

// utilities
import _ from 'lodash';

// bring in SVG
import AssessmentBank from '../../../common/svgs/AssessmentBank';
import AssessmentBenefits from '../../../common/svgs/AssessmentBenefits';
import AssessmentLaptop from '../../../common/svgs/AssessmentLaptop';
import AssessmentComercial from '../../../common/svgs/AssessmentComercial';
import AssessmentPersonal from '../../../common/svgs/AssessmentPersonal';
import AssessmentExe from '../../../common/svgs/AssessmentExe';

@connect((state) => ({
  user: state.user,
  profile: state.applicantProfile,
  assessmentUrls: state.assessmentUrls,
  tempState: state.tempState,
  staticData: state.staticData,
  skills: state.skills,
  labels: _.get(state.labels, 'Application', {}),
}))
export default class ApplicantAssessment extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    profile: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    tempState: PropTypes.object.isRequired,
    staticData: PropTypes.object.isRequired,
    skills: PropTypes.object.isRequired,
    assessmentUrls: PropTypes.object,
    labels: PropTypes.object
  };

  constructor(props, context) {
    super(props, context);
    this.state = this.refreshState();
  }

  componentDidMount() {
    const {
      profile,
      dispatch
    } = this.props;

    dispatch(applicantAssessmentUrls(profile.id, (err, assessmentUrls) => {
      if (err) {
        return console.error(err);
      }

      if (assessmentUrls && !_.isEmpty(assessmentUrls)) {
        dispatch(syncActionCreators.updateApplicant({assessmentUrls}));
      }

    }));
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.skills !== this.props.skills) {
      this.setState(this.refreshState({props: nextProps}));
    }
  }

  refreshState({props} = this) {
    const clonedAssessmentTypes = _.cloneDeep(props.staticData.assessmentTypes);

    // props.skills is a collection of collections of skills grouped by skillcategory and needs to be flattened
    const flatSkills = _.flatMapDeep(props.skills, skill => _.valuesIn(skill));
    const assessments = getAssessments(flatSkills, clonedAssessmentTypes, true);
    const objPath = 'viewState.progress.applicant.application.Assessments.done';
    const viewStateDone = _.get(props.profile, objPath, false);
    if (!viewStateDone) {
      this.updateAssessmentViewState();
    }

    return {
      assessments: _.keyBy(assessments, 'name')
    };
  }

  updateAssessmentViewState = () => {
    // if component.saveFunc is provided then use that, otherwise use default route hitting actionCreator
    const newState = _.cloneDeep(this.props.tempState);
    _.set(newState, 'user.id', this.props.user.id);
    _.set(newState, 'profile.id', this.props.profile.id);

    newState.profile.viewState = _.merge({}, this.props.profile.viewState, newState.profile.viewState, {
      progress: {applicant: {application: {Assessments: {done: true}}}}
    });

    // update front end
    this.props.dispatch(
      syncActionCreators.updateApplicant(newState)
    );


    // update back end
    this.props.dispatch(
      asyncActionCreators.persistApplicantUpdate(newState)
    );
  }

  showAssessment = (assessmentItem) => {
    return _.get(this.state, `assessments.${assessmentItem.name}.display`, false);
  }

  renderIcon(icon) {
    switch (icon) {
      case 'computer-skills':
        return <AssessmentLaptop/>;
      case 'excel':
        return <AssessmentExe/>;
      case 'personal-lines':
        return <AssessmentPersonal/>;
      case 'commercial-lines':
        return <AssessmentBank/>;
      case 'commercial-personal-lines':
        return <AssessmentComercial/>;
      case 'benefits':
        return <AssessmentBenefits/>;
      default:
        return <img src={icon}/>;
    }
  }

  render() {

    return (
      <div className='application-section-container applicant-assessment-container clearfix'>
        <div className='form-heading' data-id='Assessments Title'>
          {_.get(this.props.labels, 'ApplicantAssessment.Title')}
        </div>
        <div className='form-subheading' data-id='Assessments SubTitle'>
          {_.get(this.props.labels, 'ApplicantAssessment.SubTitle')}
        </div>
        <div className='form-text example-text'>
          {_.get(this.props.labels, 'ApplicantAssessment.Intro')}
        </div>
        <div className='assesment-sections'>
          {
            this.props.staticData.assessmentTypes.map(assessmentItem =>
              <a className='reset-href'
                 target='_blank'
                 style={{display: this.showAssessment(assessmentItem) ? 'inline-block' : 'none'}}
                 href={_.get(this.props.assessmentUrls, assessmentItem.id)}
                 data-id={`Assessments link ${assessmentItem.icon}`}>
                {this.renderIcon(assessmentItem.icon)}
                <span>{assessmentItem.name}</span>
              </a>
            )
          }
        </div>
      </div>
    );

  }

}



// WEBPACK FOOTER //
// ./shared/react/r_ApplicantDashboard/r_ApplicantAssessment/index.js